import api from './Axios'; // Your configured Axios instance

export const logoutExpert = async () => {
  // 🟢 FIXED: Point to the exact route matching your ExpertAuthController
  return api.post('/api/expert-auth/logout');
};